<template>
	<svg role="presentation" :class="iconClass" v-svg :symbol="iconName" :size="iconSize" :fill="iconFill" preserveAspectRatio="XMidYMid meet"></svg>
</template>

<script>
	export default {
		props: {
			iconName: {
				type: String,
				default: 'icon-eye'
			},
			iconSize: {
				type: String,
				default: '0 0 32 32'
			},
			iconClass: {
				type: String,
				default: 'icon'
			},
			iconFill: {
				type: String,
				default: '#ffffff'
			}
		}
	}
</script>
